import { appBarMeta } from "@constants/appbar";
import { pageViewTypes } from "@constants/tracking";
import { AppBar } from "@features/dashboard/layouts/AppBar";
import LeaderboardContainer from "@features/dashboard/screens/LeaderboardContainer";
import useAnalytics from "@hooks/useAnalytics";
import DocumentTitle from "components/DocumentTitle";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

const LeaderboardRoute = () => {
	const memoizedAnalyticsParams = useMemo(() => {
		return {
			type: pageViewTypes.leaderboard,
		};
	}, []);
	useAnalytics(memoizedAnalyticsParams);

	const { t } = useTranslation();
	return (
		<>
			<DocumentTitle title="Leaderboard" />
			<AppBar title={t(appBarMeta.leaderboard.title)} />
			<LeaderboardContainer />
		</>
	);
};

export default LeaderboardRoute;
